const DebugService = {
    isEnabled: process.env.NODE_ENV === 'development',
  
    log(...message) {
      if (this.isEnabled) {
        console.log(...message);
      }
    },
    
    warn(...message) {
      if (this.isEnabled) {
        console.warn(...message);
      }
    },
    
    error(...message) {
      // if (this.isEnabled) {
        console.error(...message);
      // }
    },
  
    // Add other debug-related methods as needed
  };
  
  export default DebugService;
  